import React from 'react';

const MyPortfolio = () => {
    return (
        <div>
            <p className='text-xl text-slate-800 mb-3'>Name : Anik Kumer Roy</p>
            <p className='text-xl text-slate-800 mb-3'>Email: roy645800@gmail.com</p>
            <p className='text-xl text-slate-800 mb-3'>Education: Honor's 2nd year,accouting</p>
            <p className='text-xl text-slate-800 mb-3'>College: Naogaon Deggre College</p>
            <p className='text-xl text-slate-800 mb-3'>My Skills: HTML,Css,Bootsrap,Tailwind,React,Mongodb,Api,Javascript,Node js</p>
            My best Website:
            1. https://handy-plus-5a529.web.app/
            2.https://fruity-garden.web.app/
            3.https://upbeat-anthem.web.app/
        </div>
    );
};

export default MyPortfolio;